// Whether a venue can take paid bookings, read from the GET /stripeConnectStatus response.
//
// canAcceptPaidBookings is the backend's full answer: payouts on AND Stripe's transfers
// capability active (see models/MongoDB/paidBookingGate.js in the API). payoutsEnabled
// alone is not enough - Stripe can switch transfers off on an account whose payouts stay
// on, and then no paid booking can be taken. A backend that predates the field doesn't
// send it, so fall back to payoutsEnabled there, the rule it replaced.
export const canTakePaidBookings = (bankStatus) =>
  typeof bankStatus?.canAcceptPaidBookings === "boolean"
    ? bankStatus.canAcceptPaidBookings
    : bankStatus?.payoutsEnabled === true;

// Payouts still on while Stripe has turned transfers off (a rejected or restricted
// account). payoutsEnabled reads as healthy here, so a screen that would otherwise say
// "connected" or "connect your bank" has to say "paused" instead.
export const paidBookingsPaused = (bankStatus) =>
  bankStatus?.payoutsEnabled === true && bankStatus?.canAcceptPaidBookings === false;
